import { combineSlices } from "@reduxjs/toolkit";
import apiService from "./api/apiService";
import { authSlice } from "./slices/authSlice";
// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.
export const rootReducer = combineSlices(
  /**
   * Static slices
   */
  authSlice,
  /**
   * Dynamic slices
   */
  {
    [apiService.reducerPath]: apiService.reducer,
  }
).withLazyLoadedSlices();
